import { LegalLayout } from "@/layouts/LegalLayout";

export function TermsPage() {
  return (
    <LegalLayout title="Termos de Uso" lastUpdated="19 de abril de 2026">
      <h2>1. Aceitação dos Termos</h2>
      <p>
        Estes Termos de Uso (&ldquo;Termos&rdquo;) regulam o acesso e a utilização
        da plataforma <strong>Cyphron</strong> (&ldquo;Plataforma&rdquo; ou
        &ldquo;Serviço&rdquo;), disponibilizada por meio dos domínios{" "}
        <strong>cyphronsec.com</strong> e <strong>api.cyphronsec.com</strong>, de
        titularidade de <strong>Henrique Almeida Porfirio</strong>, pessoa física
        em processo de constituição de pessoa jurídica (CNPJ em registro),
        doravante denominado &ldquo;Cyphron&rdquo; ou &ldquo;nós&rdquo;.
      </p>
      <p>
        Ao contratar, acessar ou utilizar a Plataforma — seja por meio de conta
        de administrador operador ou de conta de cliente contratante — você
        declara ter lido, compreendido e concordado integralmente com estes
        Termos e com a <a href="/privacidade">Política de Privacidade</a>. Caso
        não concorde com qualquer disposição, não utilize o Serviço.
      </p>

      <h2>2. Definições</h2>
      <ul>
        <li>
          <strong>Cliente:</strong> pessoa jurídica ou física contratante que
          celebra vínculo comercial com o Cyphron para uso da Plataforma.
        </li>
        <li>
          <strong>Usuário Autorizado:</strong> pessoa natural designada pelo
          Cliente para acessar a Plataforma em seu nome.
        </li>
        <li>
          <strong>Ativos Monitorados:</strong> domínios, subdomínios,
          endereços IP, endpoints HTTP/HTTPS, certificados SSL/TLS, headers de
          segurança, registros DNS, tokens de API de terceiros e demais
          recursos tecnológicos indicados pelo Cliente para monitoramento
          contínuo.
        </li>
        <li>
          <strong>Dados de Monitoramento:</strong> informações coletadas pela
          Plataforma a respeito dos Ativos Monitorados, tais como tempo de
          resposta, disponibilidade, vulnerabilidades (CVEs) identificadas,
          status de certificados, headers de segurança e similares.
        </li>
        <li>
          <strong>Subprocessadores:</strong> terceiros contratados pelo Cyphron
          para viabilizar a operação do Serviço (ex.: provedor de
          hospedagem, processador de pagamentos, provedor de autenticação).
        </li>
      </ul>

      <h2>3. Descrição do Serviço</h2>
      <p>
        O Cyphron é uma plataforma SaaS (Software as a Service) voltada a
        pequenas e médias empresas brasileiras, que presta serviços de{" "}
        <strong>monitoramento contínuo de segurança digital</strong>,
        incluindo, sem limitação: verificação de uptime, monitoramento de
        certificados SSL/TLS, avaliação de headers de segurança HTTP,
        identificação de CVEs associadas a tecnologias detectadas nos Ativos
        Monitorados, análise de configuração DNS, geração de alertas e
        emissão de relatórios periódicos.
      </p>
      <p>
        O Cyphron é ferramenta <strong>de apoio à gestão de segurança</strong>{" "}
        e não substitui: (i) equipe de segurança da informação interna ou
        terceirizada; (ii) contratação de pentest, auditoria ou consultoria
        especializada; (iii) adoção de controles organizacionais exigidos por
        normas aplicáveis ao Cliente.
      </p>

      <h2>4. Cadastro, Conta e Acesso</h2>
      <p>
        O acesso à Plataforma ocorre mediante convite emitido pelo operador do
        Cyphron após celebração do vínculo comercial. O Cliente é responsável
        por manter a confidencialidade das credenciais de acesso, por toda e
        qualquer atividade realizada por Usuários Autorizados em sua conta e
        por notificar imediatamente o Cyphron em caso de suspeita de uso não
        autorizado.
      </p>
      <p>
        O Cliente declara que as informações fornecidas no cadastro são
        verdadeiras, atuais e completas, e compromete-se a mantê-las
        atualizadas.
      </p>

      <h2>5. Planos, Pagamento e Cancelamento</h2>
      <p>
        A contratação do Serviço ocorre mediante escolha de plano e pagamento
        processado por meio do gateway <strong>Stripe</strong>. O Cyphron não
        armazena dados completos de cartão de crédito em seus servidores;
        tais dados são coletados e processados diretamente pela Stripe, em
        ambiente PCI-DSS compliant.
      </p>
      <p>
        Os planos são cobrados em ciclos recorrentes, conforme informado no
        momento da contratação. Cobranças adicionais podem ocorrer em caso de
        upgrade de plano ou contratação de módulos opcionais.
      </p>
      <p>
        O Cliente pode solicitar cancelamento a qualquer momento, mediante
        comunicação ao Cyphron por meio do canal{" "}
        <a href="mailto:support@cyphronsec.com">support@cyphronsec.com</a>. O
        cancelamento produz efeitos ao término do ciclo já pago, não havendo
        reembolso proporcional de períodos já iniciados, ressalvadas as
        hipóteses previstas no Código de Defesa do Consumidor quando
        aplicável.
      </p>

      <h2>6. Uso Aceitável</h2>
      <p>
        O Cliente compromete-se a utilizar a Plataforma exclusivamente para
        monitoramento de Ativos sobre os quais detenha{" "}
        <strong>autorização legítima</strong> — próprios, de titularidade da
        pessoa jurídica que representa, ou de terceiros que tenham expressamente
        consentido em escrito com o monitoramento.
      </p>
      <p>É expressamente vedado:</p>
      <ul>
        <li>
          cadastrar para monitoramento domínios, IPs ou endpoints sem
          autorização de seus respectivos titulares;
        </li>
        <li>
          utilizar a Plataforma para conduzir ataques, varreduras intrusivas,
          exploração de vulnerabilidades ou qualquer atividade tipificada como
          crime pela Lei nº 12.737/2012 (Lei Carolina Dieckmann) ou pela Lei nº
          14.155/2021;
        </li>
        <li>
          tentar acessar, interferir ou comprometer a infraestrutura do
          Cyphron, bem como aplicar engenharia reversa, descompilação ou
          qualquer forma de extração de código-fonte;
        </li>
        <li>
          utilizar a Plataforma para envio de spam, distribuição de malware ou
          qualquer finalidade ilícita;
        </li>
        <li>
          compartilhar credenciais de acesso com terceiros não autorizados,
          revendendo ou sublicenciando o Serviço sem autorização expressa e
          escrita do Cyphron.
        </li>
      </ul>
      <p>
        O descumprimento das regras acima autoriza o Cyphron a suspender ou
        rescindir imediatamente o acesso, sem prejuízo das medidas legais
        cabíveis.
      </p>

      <h2>7. Responsabilidades do Cliente</h2>
      <p>
        O Cliente é o único responsável por: (i) a legalidade do monitoramento
        dos Ativos cadastrados; (ii) a exatidão dos dados informados no
        cadastro; (iii) a configuração correta de tokens de API de terceiros
        (ex.: Cloudflare) fornecidos voluntariamente à Plataforma; (iv) a
        aplicação prática das recomendações geradas pelos relatórios e
        alertas; (v) o cumprimento de obrigações de segurança e proteção de
        dados que lhe sejam próprias perante seus usuários finais.
      </p>
      <p className="note">
        <strong>Importante:</strong> tokens de API fornecidos pelo Cliente (por
        exemplo, Cloudflare API Tokens) são armazenados criptografados em
        repouso. Ainda assim, recomendamos que o Cliente provisione tokens com
        escopo restrito (princípio do menor privilégio) e revogue-os
        imediatamente em caso de encerramento do contrato.
      </p>

      <h2>8. Propriedade Intelectual</h2>
      <p>
        Todo o software, código-fonte, interfaces, marca, logomarca, layout,
        identidade visual e materiais que compõem a Plataforma são de
        titularidade exclusiva do Cyphron, protegidos pela Lei nº 9.279/1996
        (Lei de Propriedade Industrial) e Lei nº 9.610/1998 (Lei de Direitos
        Autorais).
      </p>
      <p>
        O Cliente recebe apenas licença de uso limitada, não exclusiva,
        revogável e intransferível para acesso ao Serviço durante a vigência
        contratual. Nenhuma disposição destes Termos transfere direitos de
        propriedade intelectual ao Cliente.
      </p>
      <p>
        Os <strong>Dados de Monitoramento</strong> referentes aos Ativos do
        Cliente permanecem de titularidade do próprio Cliente. O Cyphron
        poderá utilizá-los exclusivamente para operação do Serviço e, em
        formato agregado e anonimizado, para fins estatísticos e de melhoria
        do produto.
      </p>

      <h2>9. Limitação de Responsabilidade</h2>
      <p>
        O Serviço é fornecido &ldquo;como está&rdquo; e &ldquo;conforme
        disponível&rdquo;. O Cyphron envida melhores esforços para garantir
        disponibilidade, exatidão e tempestividade das informações, mas{" "}
        <strong>não garante</strong> que a Plataforma identificará todas as
        vulnerabilidades, falhas de configuração ou incidentes de segurança
        existentes nos Ativos do Cliente.
      </p>
      <p>
        Dentro dos limites máximos permitidos pela legislação brasileira, o
        Cyphron não responde por:
      </p>
      <ul>
        <li>
          danos indiretos, lucros cessantes, perda de receita, perda de dados
          ou perda de oportunidade de negócio;
        </li>
        <li>
          incidentes de segurança nos ambientes do Cliente, mesmo quando
          decorrentes de vulnerabilidades não detectadas ou não comunicadas
          tempestivamente pelo Cyphron;
        </li>
        <li>
          indisponibilidade de subprocessadores, desastres naturais, ataques
          cibernéticos massivos ou outros eventos de caso fortuito ou força
          maior;
        </li>
        <li>
          atos de terceiros, incluindo Usuários Autorizados do próprio Cliente.
        </li>
      </ul>
      <p>
        Em qualquer hipótese, a responsabilidade total do Cyphron perante o
        Cliente limita-se ao valor efetivamente pago pelo Cliente nos 12
        (doze) meses anteriores ao evento que ensejou a responsabilização.
      </p>

      <h2>10. Disponibilidade e Manutenção</h2>
      <p>
        O Cyphron empenha-se em manter a Plataforma disponível de forma
        contínua, ressalvadas janelas de manutenção programadas, atualizações
        emergenciais e eventuais interrupções decorrentes de subprocessadores.
        Sempre que possível, manutenções programadas serão comunicadas com
        antecedência razoável pelos canais oficiais.
      </p>

      <h2>11. Confidencialidade</h2>
      <p>
        As Partes comprometem-se a manter sigilo sobre informações
        confidenciais recebidas em razão da relação contratual, não as
        divulgando a terceiros sem autorização escrita, salvo por determinação
        legal ou judicial. Esta obrigação permanece em vigor por 5 (cinco)
        anos após o término do contrato.
      </p>

      <h2>12. Rescisão</h2>
      <p>
        O contrato pode ser rescindido por qualquer das partes, sem multa, ao
        término do ciclo já pago, mediante comunicação por escrito ao canal{" "}
        <a href="mailto:support@cyphronsec.com">support@cyphronsec.com</a>. A
        rescisão por descumprimento material pode ocorrer imediatamente, após
        notificação e prazo razoável para sanar a violação.
      </p>
      <p>
        Em caso de rescisão, o Cyphron manterá os Dados de Monitoramento do
        Cliente pelo prazo previsto na <a href="/privacidade">Política de
        Privacidade</a> antes de sua exclusão definitiva, ressalvadas
        obrigações legais de retenção.
      </p>

      <h2>13. Alterações dos Termos</h2>
      <p>
        O Cyphron poderá atualizar estes Termos a qualquer tempo, para refletir
        mudanças legais, regulatórias ou no Serviço. Alterações materiais
        serão comunicadas ao Cliente por e-mail ou pelo painel da Plataforma
        com antecedência mínima de 15 (quinze) dias. A continuidade do uso
        após a entrada em vigor das alterações presume concordância.
      </p>

      <h2>14. Lei Aplicável e Foro</h2>
      <p>
        Estes Termos são regidos pelas leis da <strong>República Federativa do
        Brasil</strong>. Fica eleito o foro da comarca de domicílio do Cliente
        para dirimir quaisquer controvérsias decorrentes destes Termos,
        renunciando-se a qualquer outro, por mais privilegiado que seja.
      </p>

      <h2>15. Contato</h2>
      <p>
        Dúvidas, solicitações ou notificações relativas a estes Termos devem
        ser encaminhadas ao canal oficial:
      </p>
      <p>
        <strong>E-mail:</strong>{" "}
        <a href="mailto:support@cyphronsec.com">support@cyphronsec.com</a>
        <br />
        <strong>Responsável:</strong> Henrique Almeida Porfirio
      </p>
    </LegalLayout>
  );
}
